<template>
  <div>
    <cp-radio
      v-model="val"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      :label="`${label} *`"
      :hint="hint"
      @change="(value) => updateItem(name, value)">
      <slot name="hint"/>
    </cp-radio>
    <cp-radio
      v-if="val === 'YES'"
      v-model="confirm"
      :required="value === 'YES'"
      :items="detailsBasic"
      :rules="[$rules.isRequired]"
      :label="`動作確認(${label}) *`"
      @change="(value) => updateItem(`${name}_MOVEMENT_CONFIRM`, value)" />
    <v-text-field
      v-if="confirm === 'FAULT' && val === 'YES'"
      v-model="desc"
      :rules="[$rules.isRequired]"
      :label="`具体的に(${label}) *`"
      @blur="({ target })=> updateItem(`${name}_MOVEMENT_CONFIRM_DESCRIPTION`, target.value)" />
    <slot
      v-if="val === 'NO'"
      name="ifTrue"/>
  </div>
</template>

<script>
  import { yesOrNo, detailsBasic } from '../../options';

  export default {
    props: {
      label: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
      hint: {
        type: String,
        default: null,
      },
      value: {
        type: [Number, String],
        default: null,
      },
      confirmValue: {
        type: [Number, String],
        default: null,
      },
      description: {
        type: String,
        default: null,
      },
      updateItem: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        isSubForm: true,
        val: this.value,
        confirm: this.confirmValue,
        desc: this.description,
        yesOrNo,
        detailsBasic,
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/elements/CpRadioConfirmDesc.vue